export default __webpack_public_path__ + "static/Card22-802002be7924aa7988d6efa21d5345a1.png";